import React, { useMemo, cloneElement } from "react";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import TYPE from "../../constant/TYPE";

const PopupTrigger = ( props ) => {

  const user = useSelector( state => state.user );

  const {
    modal,
    closeOnDocumentClick,
    overlayStyle,
    open,
    trigger,
    children,
    ...PROPS
  } = props;

  const overlayStyleMemo = useMemo( () => {
    if ( TYPE.CHANNEL.GLOBAL01 === user.info?.channelCode && TYPE.ENTRY_TYPE.GLOBAL01 === user.info?.entryType ) {
      return { background : 'rgba( 40, 65, 80, 0.7 )' };
    } else {
      return { background : 'rgba( 50, 60, 70, 0.55 )' };
    }
  }, [ user.info?.channelCode, user.info?.entryType ] );

  const childrenMemo = useMemo( () => {
    if ( children instanceof Array ) {
      return { trigger : children[ 0 ], popup : children[ 1 ] };
    } else {
      return { popup : children };
    }
  }, [ children ] );

  return (
    <Popup
      modal
      closeOnDocumentClick={ false }
      contentStyle={ { padding : '', width : '', background : '', border : '' } }
      overlayStyle={ overlayStyleMemo }
      open={ ! childrenMemo.trigger }
      trigger={ childrenMemo.trigger }
      { ...PROPS }
    >
      { onHide => cloneElement( childrenMemo.popup, { onHide } ) }
    </Popup>
  );

};

export default PopupTrigger;
